import { z } from 'zod';

import { getTranslation } from '../../../utils/get-translation.util';
import {
  grantsFormSchema,
  safesFormSchema,
  valuationFormSchema,
} from './scenario-details.validation';

export const classConversionsFormSchema = z.object({
  exercise: z.boolean().optional(),
  classConversionItems: z
    .array(
      z.object({
        id: z.string().trim().optional(),
        shares: z.coerce
          .number({ message: getTranslation('PLEASE_ENTER_NUMERIC_VALUE') })
          .min(0, { message: getTranslation('REQUIRED') })
          .optional(),
        conversion: z.coerce
          .number({ message: getTranslation('PLEASE_ENTER_NUMERIC_VALUE') })
          .optional(),
        convertedShares: z.coerce
          .number({ message: getTranslation('PLEASE_ENTER_NUMERIC_VALUE') })
          .optional(),
        shareClass: z.object({
          name: z
            .string()
            .trim()
            .min(1, { message: getTranslation('REQUIRED') }),
          id: z
            .string()
            .trim()
            .min(1, { message: getTranslation('REQUIRED') }),
        }),
        classConversionTaskId: z
          .string()
          .trim()
          .min(1, { message: getTranslation('REQUIRED') }),
        stakeholder: z.object({
          fullName: z
            .string()
            .trim()
            .min(1, { message: getTranslation('REQUIRED') }),
          id: z.string().trim(),
        }),
      }),
    )
    .optional(),
});

export const liquidityFormSchema = z.object({
  valuation: valuationFormSchema,
  safes: safesFormSchema.optional(),
  grants: grantsFormSchema.optional(),
  classConversion: classConversionsFormSchema.optional(),
  accelerateVesting: z.boolean().optional(),
});

export type LiquidityFormSchema = z.infer<typeof liquidityFormSchema>;
